<template>
    <div class="home home_i " ref="scrollContainer">
      <div class="home-header">
        <headerTop :opacity="opacity" />
        <div class="header-font">
          <p class="header-font-p">
            智领未来，触手可及，共建智能生态
          </p>
          <p class="header-font-t">
            大模型广场，AI时代的创新引擎！赋能千行百业！
          </p>
          <p class="header-font-s">
            让每个创意都有AI翅膀，飞向智能新纪元！
          </p>
        </div>
        <!-- <div class="home-box">
          <div class="home-box-content">
            <div class="box-list">
              <div class="list-box">
                <svg
                  t="1742963768980"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2758"
                  width="40"
                  height="40"
                >
                  <defs>
                    <linearGradient
                      id="gradientx"
                      x1="0%"
                      y1="0%"
                      x2="0%"
                      y2="100%"
                    >
                      <stop
                        offset="0%"
                        style="stop-color: #7aaafd; stop-opacity: 1"
                      />
                      <stop
                        offset="100%"
                        style="stop-color: #3981fe; stop-opacity: 1"
                      />
                    </linearGradient>
                  </defs>
                  <path
                    d="M744.040284 124.508671L535.172275 6.133778a47.081166 47.081166 0 0 0-46.377189 0l-208.953339 118.396226c-7.167772 4.053204-13.119582 9.919684-17.258117 17.002125a46.142529 46.142529 0 0 0-6.314465 23.31659v235.960479a46.163862 46.163862 0 0 1-23.295258 40.254716l-209.614652 120.465494A46.291858 46.291858 0 0 0 0 601.82679v235.981812c0 8.191739 2.175931 16.212817 6.314465 23.31659 4.159867 7.082441 10.111678 12.948921 17.27945 17.002124l208.868009 118.460224c14.420874 8.085076 31.956315 8.085076 46.377188 0l209.891976-118.758881a47.017168 47.017168 0 0 1 46.441187 0l209.891976 118.737549c14.420874 8.106408 32.084311 8.106408 46.377188 0l208.868009-118.438892c7.189104-4.053204 13.140914-9.919684 17.300782-17.002124 4.159867-7.082441 6.357131-15.146184 6.357131-23.31659V601.82679a46.291858 46.291858 0 0 0-23.359255-40.254717l-209.614652-120.529491a46.163862 46.163862 0 0 1-23.380588-40.254717V164.763388a46.163862 46.163862 0 0 0-23.572582-40.318715v0.063998z m-181.967533 158.565613v246.733468l213.923847 122.662757a17.386112 17.386112 0 0 1 8.575727 17.36478 17.279449 17.279449 0 0 1-2.218596 6.421129l-28.500425 49.065102a17.45011 17.45011 0 0 1-17.471443 8.533062 17.556774 17.556774 0 0 1-6.463794-2.175931l-214.222505-122.876083-214.201172 122.812085a17.514108 17.514108 0 0 1-23.95657-6.378463l-28.479092-49.065103a17.300782 17.300782 0 0 1 6.335798-23.764576l214.649158-123.046744V283.010286c0-9.663692 7.786418-17.492776 17.45011-17.492776h57.043516c9.685025 0 17.535441 7.893082 17.535441 17.492776v0.063998z"
                    fill="url(#gradientx)"
                    p-id="2759"
                  ></path>
                </svg>
  
                <div class="list-box-content">
                  <span style="font-size: 1.4rem; color: #333; font-weight: bold"
                    >111</span
                  >
                  <span style="font-size: 0.85rem">模型托管数量</span>
                </div>
                <div class="list-box-content">
                  <span style="font-size: 1.4rem; color: #333; font-weight: bold"
                    >65</span
                  >
                  <span style="font-size: 0.85rem">模型部署数量</span>
                </div>
              </div>
              <el-divider direction="vertical"></el-divider>
              <div class="list-box">
                <svg
                  t="1742965679316"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2937"
                  width="40"
                  height="40"
                >
                  <defs>
                    <linearGradient
                      id="gradientxl"
                      x1="0%"
                      y1="0%"
                      x2="0%"
                      y2="100%"
                    >
                      <stop
                        offset="0%"
                        style="stop-color: #7aaafd; stop-opacity: 1"
                      />
                      <stop
                        offset="100%"
                        style="stop-color: #3981fe; stop-opacity: 1"
                      />
                    </linearGradient>
                  </defs>
                  <path
                    d="M988.821333 353.749333l-148.629333 148.693334a120.085333 120.085333 0 0 1-169.834667 0l-148.650666-148.693334a120.149333 120.149333 0 0 1 0-169.898666l148.650666-148.672a120.106667 120.106667 0 0 1 169.813334 0l148.650666 148.693333a120.149333 120.149333 0 0 1 0 169.877333z m-658.410666 140.202667H120.021333A120.106667 120.106667 0 0 1 0 373.888V163.712a120.170667 120.170667 0 0 1 120.021333-120.32h210.133334a120.170667 120.170667 0 0 1 120.277333 120.064v210.154667a120.170667 120.170667 0 0 1-120.021333 120.32zM860.330667 1024h-210.133334a120.106667 120.106667 0 0 1-120.021333-120.064v-210.154667a120.106667 120.106667 0 0 1 120.042667-120.064h210.112a120.106667 120.106667 0 0 1 120.021333 120.064v210.154667A120.106667 120.106667 0 0 1 860.330667 1024z m-529.92 0H120.021333A120.106667 120.106667 0 0 1 0 903.936v-210.154667a120.170667 120.170667 0 0 1 120.021333-120.32h210.133334a120.106667 120.106667 0 0 1 120.021333 120.042667v210.176a119.893333 119.893333 0 0 1-73.813333 111.146667 119.765333 119.765333 0 0 1-45.952 9.173333z"
                    fill="url(#gradientxl)"
                    p-id="2938"
                  ></path>
                </svg>
  
                <div class="list-box-content">
                  <span style="font-size: 1.4rem; color: #333; font-weight: bold"
                    >111</span
                  >
                  <span style="font-size: 0.85rem">加速卡数量</span>
                </div>
                <div class="list-box-content">
                  <span style="font-size: 1.4rem; color: #333; font-weight: bold"
                    >65</span
                  >
                  <span style="font-size: 0.85rem">加速卡数量</span>
                </div>
                <div class="list-box-content">
                  <span style="font-size: 1.4rem; color: #333; font-weight: bold"
                    >65</span
                  >
                  <span style="font-size: 0.85rem">占用加速卡</span>
                </div>
              </div>
              <el-divider direction="vertical"></el-divider>
              <div class="list-box">
                <svg
                  t="1742965790260"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="3116"
                  width="40"
                  height="40"
                >
                  <defs>
                    <linearGradient
                      id="gradientxa"
                      x1="0%"
                      y1="0%"
                      x2="0%"
                      y2="100%"
                    >
                      <stop
                        offset="0%"
                        style="stop-color: #7aaafd; stop-opacity: 1"
                      />
                      <stop
                        offset="100%"
                        style="stop-color: #3981fe; stop-opacity: 1"
                      />
                    </linearGradient>
                  </defs>
                  <path
                    d="M326.4 462.933333h-17.066667v108.8l8.533334 2.133334h8.533333c14.933333 0 25.6-4.266667 34.133333-12.8 8.533333-8.533333 12.8-23.466667 12.8-40.533334 0-19.2-4.266667-32-12.8-42.666666-8.533333-10.666667-19.2-14.933333-34.133333-14.933334z"
                    p-id="3117"
                    fill="url(#gradientxa)"
                  ></path>
                  <path
                    d="M985.6 558.933333c10.666667 0 21.333333-6.4 27.733333-14.933333 6.4-8.533333 10.666667-19.2 8.533334-29.866667 0-10.666667-6.4-21.333333-14.933334-27.733333-8.533333-6.4-19.2-10.666667-29.866666-8.533333h-100.266667v-123.733334h108.8c10.666667 0 21.333333-6.4 27.733333-14.933333 6.4-8.533333 10.666667-19.2 8.533334-29.866667 0-10.666667-6.4-21.333333-14.933334-27.733333-8.533333-6.4-19.2-10.666667-29.866666-8.533333H874.666667c-4.266667-29.866667-19.2-59.733333-40.533334-81.066667s-51.2-38.4-81.066666-42.666667V66.133333c0-10.666667-4.266667-21.333333-12.8-29.866666-8.533333-8.533333-19.2-12.8-29.866667-12.8s-21.333333 4.266667-29.866667 12.8c-8.533333 8.533333-12.8 19.2-12.8 29.866666V149.333333h-123.733333V57.6c-2.133333-12.8-8.533333-23.466667-19.2-32-6.4-4.266667-14.933333-6.4-21.333333-6.4-8.533333 0-14.933333 2.133333-21.333334 6.4-6.4 4.266667-12.8 10.666667-14.933333 17.066667-4.266667 6.4-4.266667 14.933333-4.266667 21.333333v85.333333H341.333333V57.6c0-10.666667-6.4-21.333333-14.933333-27.733333s-17.066667-8.533333-29.866667-8.533334c-10.666667 0-21.333333 6.4-27.733333 14.933334-6.4 8.533333-10.666667 19.2-8.533333 29.866666V149.333333c-32 4.266667-61.866667 21.333333-85.333334 44.8-21.333333 23.466667-36.266667 55.466667-38.4 87.466667H36.266667c-10.666667 2.133333-21.333333 6.4-27.733334 14.933333-4.266667 8.533333-8.533333 19.2-8.533333 29.866667 0 10.666667 6.4 21.333333 14.933333 27.733333 8.533333 6.4 19.2 10.666667 29.866667 10.666667h91.733333v123.733333H36.266667c-10.666667 0-21.333333 6.4-27.733334 14.933334s-8.533333 17.066667-8.533333 27.733333 6.4 21.333333 14.933333 27.733333c8.533333 6.4 19.2 10.666667 29.866667 8.533334h91.733333v123.733333H44.8c-10.666667 0-21.333333 4.266667-29.866667 12.8-8.533333 8.533333-12.8 19.2-12.8 29.866667s4.266667 21.333333 12.8 29.866666c8.533333 8.533333 19.2 12.8 29.866667 12.8h96c6.4 27.733333 21.333333 55.466667 42.666667 74.666667 21.333333 19.2 49.066667 32 76.8 36.266667v91.733333c2.133333 10.666667 6.4 21.333333 14.933333 27.733333 8.533333 6.4 19.2 10.666667 29.866667 8.533334 10.666667 0 21.333333-6.4 27.733333-14.933334 6.4-8.533333 10.666667-19.2 10.666667-29.866666v-81.066667h123.733333v89.6c0 10.666667 6.4 21.333333 14.933333 27.733333 8.533333 6.4 19.2 10.666667 29.866667 8.533334 10.666667 0 21.333333-6.4 27.733333-14.933334s10.666667-19.2 8.533334-29.866666v-81.066667h121.6v81.066667c0 10.666667 4.266667 21.333333 12.8 29.866666 8.533333 8.533333 19.2 12.8 29.866666 12.8 10.666667 0 21.333333-4.266667 29.866667-12.8 8.533333-8.533333 12.8-19.2 12.8-29.866666v-83.2c29.866667-4.266667 59.733333-19.2 81.066667-40.533334 21.333333-21.333333 36.266667-51.2 40.533333-81.066666H981.333333c10.666667 0 19.2-6.4 25.6-12.8 6.4-8.533333 10.666667-17.066667 10.666667-27.733334s-4.266667-19.2-10.666667-27.733333-17.066667-12.8-25.6-12.8h-100.266666v-123.733333h104.533333z m-563.2 2.133334c-4.266667 12.8-12.8 23.466667-21.333333 32-8.533333 8.533333-21.333333 14.933333-34.133334 19.2-12.8 4.266667-27.733333 6.4-42.666666 6.4h-12.8l-12.8-4.266667-14.933334-2.133333c-4.266667 0-8.533333-2.133333-12.8-4.266667-10.666667-4.266667-17.066667-12.8-17.066666-23.466667v-145.066666-6.4c0-2.133333 2.133333-4.266667 2.133333-4.266667 2.133333-2.133333 6.4-4.266667 10.666667-6.4 8.533333-2.133333 19.2-4.266667 27.733333-6.4 10.666667 0 19.2-2.133333 27.733333-2.133333 17.066667 0 29.866667 2.133333 44.8 6.4 12.8 4.266667 23.466667 10.666667 34.133334 19.2 8.533333 8.533333 17.066667 19.2 21.333333 29.866666 4.266667 12.8 8.533333 27.733333 8.533333 44.8 0 19.2-4.266667 34.133333-8.533333 46.933334z m166.4 38.4c-2.133333 4.266667-6.4 6.4-12.8 10.666666-4.266667 2.133333-8.533333 4.266667-14.933333 4.266667-6.4 2.133333-14.933333 2.133333-25.6 2.133333-14.933333 0-27.733333-2.133333-40.533334-6.4-12.8-4.266667-23.466667-10.666667-32-17.066666-8.533333-8.533333-17.066667-19.2-21.333333-32-4.266667-12.8-8.533333-27.733333-8.533333-44.8s2.133333-29.866667 8.533333-42.666667c4.266667-12.8 12.8-23.466667 21.333333-32 8.533333-8.533333 19.2-14.933333 32-19.2 12.8-4.266667 25.6-6.4 38.4-6.4 19.2 0 34.133333 2.133333 44.8 8.533333 10.666667 6.4 14.933333 14.933333 14.933334 23.466667 0 6.4-2.133333 10.666667-4.266667 14.933333-2.133333 4.266667-6.4 6.4-8.533333 8.533334-6.4-4.266667-10.666667-6.4-17.066667-8.533334-6.4-2.133333-14.933333-4.266667-21.333333-4.266666-14.933333 0-27.733333 4.266667-36.266667 14.933333-8.533333 10.666667-12.8 23.466667-12.8 40.533333 0 19.2 4.266667 32 12.8 42.666667 8.533333 8.533333 21.333333 14.933333 38.4 14.933333 8.533333 0 14.933333-2.133333 21.333333-4.266666 6.4-2.133333 10.666667-4.266667 17.066667-8.533334 4.266667 2.133333 6.4 6.4 8.533333 10.666667 2.133333 4.266667 2.133333 8.533333 2.133334 14.933333-2.133333 6.4-2.133333 12.8-4.266667 14.933334z m181.333333-55.466667c0 10.666667-2.133333 21.333333-6.4 29.866667-4.266667 8.533333-8.533333 17.066667-17.066666 23.466666-8.533333 6.4-17.066667 12.8-25.6 14.933334-10.666667 4.266667-23.466667 6.4-34.133334 4.266666-12.8 0-23.466667-2.133333-34.133333-4.266666s-19.2-8.533333-25.6-14.933334c-6.4-6.4-12.8-14.933333-17.066667-23.466666-4.266667-10.666667-6.4-19.2-6.4-29.866667v-119.466667l10.666667-2.133333c4.266667 0 8.533333-2.133333 14.933333-2.133333 10.666667 0 17.066667 2.133333 21.333334 4.266666 4.266667 4.266667 6.4 10.666667 6.4 21.333334v96c0 10.666667 2.133333 17.066667 8.533333 23.466666 6.4 6.4 12.8 8.533333 21.333333 8.533334 4.266667 0 8.533333 0 10.666667-2.133334 4.266667-2.133333 6.4-4.266667 10.666667-6.4 6.4-6.4 8.533333-12.8 8.533333-23.466666v-119.466667l10.666667-2.133333c4.266667 0 8.533333-2.133333 14.933333-2.133334 10.666667 0 17.066667 2.133333 23.466667 4.266667 4.266667 4.266667 6.4 10.666667 6.4 21.333333v100.266667z"
                    p-id="3118"
                    fill="url(#gradientxa)"
                  ></path>
                </svg>
  
                <div class="list-box-content">
                  <span style="font-size: 1.4rem; color: #333; font-weight: bold"
                    >30%</span
                  >
                  <span style="font-size: 0.85rem">系统负载</span>
                </div>
              </div>
              <el-divider direction="vertical"></el-divider>
              <div class="list-box">
                <svg
                  t="1742965994399"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="3296"
                  width="40"
                  height="40"
                >
                  <defs>
                    <linearGradient
                      id="gradientxc"
                      x1="0%"
                      y1="0%"
                      x2="0%"
                      y2="100%"
                    >
                      <stop
                        offset="0%"
                        style="stop-color: #7aaafd; stop-opacity: 1"
                      />
                      <stop
                        offset="100%"
                        style="stop-color: #3981fe; stop-opacity: 1"
                      />
                    </linearGradient>
                  </defs>
                  <path
                    d="M755.413333 579.989333A391.232 391.232 0 0 0 513.92 981.333333H42.666667c0-259.2 210.133333-469.333333 469.333333-469.333333 89.130667 0 172.437333 24.832 243.413333 67.989333zM512 512c-129.6 0-234.666667-105.066667-234.666667-234.666667S382.4 42.666667 512 42.666667s234.666667 105.066667 234.666667 234.666666-105.066667 234.666667-234.666667 234.666667z m195.541333 156.458667H981.333333V746.666667H707.541333v-78.208z m-78.208 117.333333H981.333333V864H629.333333v-78.208z m-39.125333 117.333333H981.333333V981.333333H590.208v-78.208z"
                    fill="url(#gradientxc)"
                    p-id="3297"
                  ></path>
                </svg>
  
                <div class="list-box-content">
                  <span style="font-size: 1.4rem; color: #333; font-weight: bold"
                    >124</span
                  >
  
                  <span style="font-size: 0.85rem">在线用户</span>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="box-content-tab">
          <div class="content-tab-left">
            <div style="padding:20px 10px;">
              <svg style="    vertical-align: text-top;" t="1742967131245" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3509" width="18" height="18"><path d="M1008.064 306.56L789.461333 525.162667a51.52 51.52 0 0 1-72.874666 0L498.005333 306.538667a51.477333 51.477333 0 0 1 0-72.832L716.586667 15.104a51.52 51.52 0 0 1 72.874666 0l218.602667 218.602667a51.477333 51.477333 0 0 1 0 72.853333zM753.429333 54.826667L537.728 270.506667l215.701333 215.722666L969.173333 270.528 753.429333 54.826667zM369.621333 1023.957333H56.874667A56.853333 56.853333 0 0 1 0 967.104v-312.746667a56.874667 56.874667 0 0 1 56.853333-56.874666h312.746667a56.874667 56.874667 0 0 1 56.874667 56.874666v312.746667a56.874667 56.874667 0 0 1-56.853334 56.853333z m0-369.6H56.874667v312.746667h312.746666v-312.746667z m0-142.165333H56.874667A56.853333 56.853333 0 0 1 0 455.338667V142.592a56.874667 56.874667 0 0 1 56.853333-56.874667h312.746667a56.874667 56.874667 0 0 1 56.874667 56.874667v312.746667a56.874667 56.874667 0 0 1-56.853334 56.853333z m0-369.6H56.874667v312.746667h312.746666V142.592z m199.018667 454.890667h312.746667a56.874667 56.874667 0 0 1 56.853333 56.874666v312.746667a56.874667 56.874667 0 0 1-56.853333 56.853333h-312.746667a56.853333 56.853333 0 0 1-56.874667-56.853333v-312.746667a56.874667 56.874667 0 0 1 56.874667-56.874666z m0 369.621333h312.746667v-312.746667h-312.746667v312.746667z" fill="#333333" p-id="3510"></path></svg>
              <span style="font-size: 1.1rem;">应用列表</span>
              <span style="float: right;font-size: 0.85rem;margin-top: 4px;color:#666">共有 <span style="color:#4384F4;font-weight: 500;">{{all}}</span> 个应用</span>
            </div>
            <el-divider ></el-divider>
            <ul class="box-list-left">
              <li :class="indexCur==0?'active':''" @click="clickList(0,'知识库')">
                <svg t="1742967772755" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3726" width="20" height="20"><path d="M1009.450667 346.197333c-1.216-7.914667-5.482667-14.613333-13.397334-17.664L519.893333 106.88c-14.016-6.08-31.061333-6.08-43.242666 0.64L26.688 329.130667c-7.317333 4.266667-12.181333 11.562667-12.181333 19.477333 0 7.893333 4.864 14.613333 12.8 18.261333l168.64 83.413334v313.6c0 10.944 6.698667 20.693333 17.066666 25.557333l279.466667 129.088c4.266667 1.834667 8.533333 3.050667 13.397333 3.050667 4.266667 0 9.130667-1.216 13.397334-3.050667l279.488-129.066667c10.346667-4.885333 17.066667-14.634667 17.066666-25.6v-312.96l52.352-24.96v119.338667c0 15.232 15.210667 32.874667 35.306667 32.874667 22.528 0 32.277333-23.744 32.277333-32.874667v-150.4l61.504-28.608c8.533333-4.266667 12.8-11.584 12.16-20.096z m-120.576 1.216l-390.293334 182.058667-369.6-182.058667L499.178667 165.333333l389.696 182.058667z m-621.674667 137.002667l210.069333 103.509333c6.698667 3.050667 13.397333 4.864 21.312 4.864 7.893333 0 14.613333-1.813333 21.312-4.864l226.496-105.344v247.829334l-241.109333 116.288-238.08-116.288V484.416z" :fill="indexCur==0?'#ffffff':'#666666'" p-id="3727"></path></svg>
                <span>知识库</span>
              </li>
              <li :class="indexCur==1?'active':''" @click="clickList(1,'数据分析')">
                <svg t="1742969303445" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3981" width="20" height="20"><path d="M799.744 749.717333H541.056v93.738667h196.842667c14.997333 0 28.117333 13.12 28.117333 28.117333 0 14.997333-13.12 28.117333-28.117333 28.117334h-449.92c-14.997333 0-28.117333-13.12-28.117334-28.117334 0-14.997333 13.12-28.117333 28.117334-28.117333h196.842666v-93.738667H224.256A121.6 121.6 0 0 1 102.4 627.861333v-352.426666A121.6 121.6 0 0 1 224.256 153.6h575.488a121.6 121.6 0 0 1 121.856 121.856v352.426667a121.6 121.6 0 0 1-121.856 121.834666zM224.256 209.834667c-35.626667 0-65.621333 29.994667-65.621333 65.621333v352.426667c0 35.626667 29.994667 65.6 65.621333 65.6h575.488c35.626667 0 65.621333-29.994667 65.621333-65.6v-352.426667c0-35.626667-29.994667-65.621333-65.621333-65.621333H224.256z m41.237333 382.421333c5.632 3.754667 13.12 7.488 20.608 7.488 9.386667 0 16.874667-3.733333 18.773334-7.488l146.197333-146.218667 73.109333 73.109334c9.386667 7.488 20.629333 13.12 33.749334 13.12 13.12 0 24.362667-3.754667 33.749333-13.12l164.949333-164.970667a27.178667 27.178667 0 0 0 0-39.36 27.178667 27.178667 0 0 0-39.36 0l-159.36 159.338667-73.088-73.109334c-16.874667-18.752-46.869333-18.752-65.621333 0l-153.706667 151.850667a27.178667 27.178667 0 0 0 0 39.36z" :fill="indexCur==1?'#ffffff':'#666666'" p-id="3982"></path></svg>  
                <span>数据分析</span>
              </li>
              <li :class="indexCur==2?'active':''" @click="clickList(2,'智能办公')">
                <svg t="1742969405123" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4200" width="20" height="20"><path d="M822.08 256.021333h-155.050667v-51.2A51.413333 51.413333 0 0 0 615.317333 153.6h-206.634666a51.434667 51.434667 0 0 0-51.712 51.2v51.221333H201.92c-57.088 0-103.317333 45.845333-103.317333 102.421334V819.2c0 56.490667 46.336 102.421333 103.317333 102.421333h620.16c57.088 0 103.317333-45.845333 103.317333-102.421333V358.442667c0.085333-56.576-46.229333-102.4-103.317333-102.4z m-393.770667-25.6c0-14.144 9.365333-25.6 20.906667-25.6h125.546667c11.562667 0 20.928 11.456 20.928 25.6V256h-167.381334v-25.6zM853.76 798.506667c0 28.309333-21.824 51.242667-48.832 51.242666H219.093333c-27.008 0-48.832-22.933333-48.832-51.221333V577.856h247.509334c-2.005333 8.256-3.498667 25.706667-3.498667 34.56 0 56.512 43.733333 102.336 97.642667 102.336s97.642667-45.824 97.642666-102.314667c0-8.874667-1.386667-26.304-3.477333-34.581333h247.68v220.693333z m0-292.224H170.24v-127.936c0-28.288 21.824-51.2 48.832-51.2H804.906667c27.008 0 48.832 22.912 48.832 51.2v127.936z" :fill="indexCur==2?'#ffffff':'#666666'"  p-id="4201"></path></svg>        
                  <span>智能办公</span>
              </li>
              <li :class="indexCur==3?'active':''" @click="clickList(3,'AIGC')">
               <svg t="1742969432205" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4419" width="20" height="20"><path d="M501.376 51.626667c18.56-1.493333 37.248 1.024 54.762667 7.424l9.472 3.968 9.386666 4.821333 279.189334 157.482667a123.306667 123.306667 0 0 1 62.848 97.450666l0.384 9.834667v76.245333l5.973333 2.709334a81.664 81.664 0 0 1 47.744 88.149333 83.285333 83.285333 0 0 1-74.730667 67.946667c-2.645333 0.362667-5.354667 0.362667-8.021333 0.362666a84.224 84.224 0 0 1-78.528-53.184 81.066667 81.066667 0 0 1 29.674667-95.424l4.288-2.901333v-83.946667a50.986667 50.986667 0 0 0-19.776-40.469333l-5.888-4.010667-279.978667-157.994666a54.634667 54.634667 0 0 0-45.738667-3.456l-6.528 3.072-324.885333 183.253333a37.418667 37.418667 0 0 1-35.605333 0.64 35.477333 35.477333 0 0 1-5.589334-59.989333l4.693334-3.093334 324.010666-182.741333a128.981333 128.981333 0 0 1 52.842667-16.149333zM485.333333 893.866667c8.085333 4.522667 17.173333 6.954667 26.432 6.954666l-0.149333 0.042667c6.613333 0.064 13.184-1.066667 19.370667-3.413333l6.442666-2.88 325.162667-183.338667a37.461333 37.461333 0 0 1 48.981333 11.050667 35.52 35.52 0 0 1-7.786666 48.256l-4.757334 2.901333-323.946666 182.784a129.130667 129.130667 0 0 1-117.12 4.8l-9.536-4.906667-279.253334-157.482666a123.242667 123.242667 0 0 1-62.890666-97.450667l-0.32-9.792v-128.085333l-6.016-2.709334a81.92 81.92 0 0 1-46.933334-91.989333 84.416 84.416 0 0 1 161.813334-7.594667 80.682667 80.682667 0 0 1-30.976 91.690667l-4.309334 2.944v135.786667a51.242667 51.242667 0 0 0 19.797334 40.426666l6.016 4.010667L485.333333 893.866667z m113.450667-217.408L479.573333 349.226667H398.912l-117.546667 327.253333h75.456l24.533334-74.752h117.504l24.533333 74.752h75.392z m110.442667-1.770667V347.392h-68.352v327.317333h68.352zM441.002667 404.245333h1.685333c1.237333 9.6 2.986667 19.093333 5.226667 28.501334l36.864 113.706666h-85.909334l36.864-113.749333c2.602667-9.322667 4.352-18.837333 5.269334-28.458667z" :fill="indexCur==3?'#ffffff':'#666666'"  p-id="4420"></path></svg>
                <span>AIGC</span>
              </li>
              <li :class="indexCur==4?'active':''" @click="clickList(4,'软件开发')">
                <svg t="1742969462849" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4674" width="20" height="20"><path d="M877.397333 788.885333a40.746667 40.746667 0 0 1 0 81.514667H143.701333a40.746667 40.746667 0 1 1 0-81.514667h733.696zM338.474667 165.525333a40.768 40.768 0 0 1 0 57.642667l-201.770667 201.728 201.749333 201.749333a40.768 40.768 0 0 1-57.621333 57.685334L50.24 453.738667a40.746667 40.746667 0 0 1 0-57.621334L280.832 165.525333a40.746667 40.746667 0 0 1 57.642667 0z m347.050666 0a40.746667 40.746667 0 0 1 53.824-3.370666l3.84 3.392 230.549334 230.570666a40.768 40.768 0 0 1 3.413333 53.802667l-3.904 4.330667-230.08 230.08a40.746667 40.746667 0 0 1-61.013333-53.802667l3.370666-3.84 201.770667-201.813333-201.770667-201.706667a40.746667 40.746667 0 0 1 0-57.642667z m-108.778666 23.210667a40.746667 40.746667 0 0 1 28.8 49.877333l-105.472 393.749334a40.768 40.768 0 0 1-78.741334-21.12l105.493334-393.749334a40.746667 40.746667 0 0 1 49.92-28.757333z" :fill="indexCur==4?'#ffffff':'#666666'" p-id="4675"></path></svg>
                <span>软件开发</span>
              </li>
              <li :class="indexCur==5?'active':''" @click="clickList(5,'数字人')">
                <svg t="1742969492301" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4893" width="20" height="20"><path d="M544.213333 102.4c161.002667 0 291.2 72.96 348.245334 195.2v-0.085333c60.906667 130.666667 25.386667 291.584-97.536 442.922666v118.762667a30.933333 30.933333 0 1 1-61.888 0v-129.92c-0.021333-7.253333 2.517333-14.293333 7.146666-19.84 112.704-134.698667 147.754667-275.242667 96.213334-385.706667C789.717333 223.808 680.533333 164.266667 544.106667 164.266667c-272.725333 0-293.973333 296.533333-294.72 309.12a31.274667 31.274667 0 0 1-12.714667 23.253333c-1.088 0.810667-48.021333 35.797333-71.616 88.746667 4.842667 11.413333 50.346667 23.616 90.602667 25.6a30.954667 30.954667 0 0 1 29.44 30.890666v191.125334h155.477333a30.933333 30.933333 0 1 1 0 61.866666h-186.410667a30.933333 30.933333 0 0 1-30.933333-30.933333v-193.792c-36.992-4.821333-91.2-17.536-112.042667-51.392-10.752-17.429333-11.669333-38.186667-2.688-58.453333 22.890667-51.52 61.44-88.576 80.533334-104.746667C197.504 387.84 250.56 102.4 544.213333 102.4z m109.845334 217.472a30.933333 30.933333 0 0 1 11.861333-2.346667v0.042667a30.933333 30.933333 0 0 1 30.933333 30.933333v273.834667a30.954667 30.954667 0 0 1-61.930666 0V348.522667a30.912 30.912 0 0 1 19.136-28.650667z m-172.8 139.456l-24.874667 69.077333h48.426667l-23.573334-69.077333z m18.773333-118.677333c5.205333 3.754667 9.130667 9.045333 11.178667 15.146666v-0.128l90.901333 265.877334a30.976 30.976 0 0 1-58.602667 19.968l-17.450666-51.285334h-91.946667l-18.56 51.818667a30.954667 30.954667 0 1 1-58.24-21.034667l95.530667-265.706666a30.933333 30.933333 0 0 1 29.12-20.522667h0.170666c6.442667 0.042667 12.693333 2.090667 17.898667 5.866667z" :fill="indexCur==5?'#ffffff':'#666666'"  p-id="4894"></path></svg>
                <span>数字人</span>
              </li>
  
  
            </ul>
  
          </div>
          <div class="content-tab-right">
            <div style="text-align: left">
              <el-input
                v-model="seach"
                placeholder="请输入您要查询的应用"
                style="width: 700px; border-radius: 40px"
                @blur="initSeach"
                @keyup.enter.native="initSeach"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i
              ></el-input>
            </div>
            <div class="card-box" v-if="cardAry.length>0">
              <div class="box-card" v-for="(item,index) in cardAry" :key="index"                  style="position: relative">
                <div style="    position: absolute;
    right: -1px;
    background: rgb(235, 66, 52);
    color: rgb(255, 255, 255);
    top: -1px;
    padding: 2px 8px;
    min-width: 20px;
    border-radius: 0px 5px;
    font-size: 12px;" v-if="item.tags!=''">{{ item.tags }}</div>
                <div class="card-item">
                  <div style="margin-right: 10px">
                    <img src="../image/temp.png" width="40px" />
                  </div>
                  <div>
                    <p class="item-title">{{item.title}}</p>
                    <p>
                      <el-tag size="mini">{{ item.type }}</el-tag>
                      <!-- <el-tag size="mini" type="info">V1.0</el-tag>
                      <el-tag size="mini" type="info">INT4</el-tag>
                      <el-tag size="mini" type="info">≥ 8K</el-tag>
                      <el-tag size="mini" type="info">10B~50B</el-tag> -->
                    </p>
                  </div>
                </div>
                <p class="item-detail">
                  {{item.intro}}
                </p>
                <!-- <p class="item-dis">     {{ item.provider }} . 发布于
                  {{ formatDateTime(item.pubdate) }}</p> -->
                <el-divider></el-divider>
                <div class="item-btn">
                  <div class="btn-color" @click="tyurl(index, item.url_test)">
                    <svg
                      t="1743036976765"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="5367"
                      width="16"
                      height="16"
                    >
                      <path
                        d="M512 1002.666667a490.666667 490.666667 0 1 1 0-981.333334 490.666667 490.666667 0 0 1 0 981.333334z m0-905.856a415.168 415.168 0 1 0 0 830.357333 415.168 415.168 0 0 0 0-830.357333z m-61.653333 598.186666a34.346667 34.346667 0 0 1-19.050667 5.717334 31.274667 31.274667 0 0 1-32.533333-30.186667V353.472c0.042667-6.4 2.218667-12.586667 6.186666-17.578667a34.346667 34.346667 0 0 1 45.290667-6.570666l237.034667 158.506666c2.88 1.792 5.44 4.032 7.552 6.656a28.373333 28.373333 0 0 1-7.552 41.749334L450.346667 694.976z"
                        fill="#2c3e50"
                        p-id="5368"
                      ></path>
                    </svg>
                    <span>在线体验</span>
                  </div>
                  <el-divider direction="vertical"></el-divider>
                  <div @click="tyurl(index, item.url_api)">
                    <img
                      src="../image/api.png"
                      width="16px;"
                      style="margin-right: 6px"
                    /><span>API文档</span>
                  </div>
                </div>
              </div>
            
            </div>
            <el-empty description="暂无数据" v-else></el-empty>
            <el-pagination
              :hide-on-single-page="true"
              style="text-align: right; margin-top: 10px"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
                :page-sizes="[10, 15, 20, 25, 30]"
              :page-size="limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>

      </div>
      <el-backtop 
  target=".home"
  :bottom="100"
  :right="40"
  class="custom-backtop">
  <i class="el-icon-caret-top"></i>
</el-backtop>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import headerTop from "@/components/headerTop.vue";
  
  export default {
    name: "Home",
    components: {
      headerTop,
    },
    data() {
      return {
        opacity: false,
        indexCur:null,
        currentPage:1,
        total:0,
        cardAry:[],
        all:0,
        limit:10,
        seach:'',
        type:''
      };
    },
    mounted() {
      // 获取滚动容器（height:calc(100vh - 60px) 的 div）
      const scrollContainer = this.$refs.scrollContainer;
      scrollContainer.addEventListener("scroll", this.handleScroll);
      this.handleResize();
    // window.addEventListener("resize", this.handleResize);

    },
    beforeDestroy() {
      const scrollContainer = this.$refs.scrollContainer;
      scrollContainer.removeEventListener("scroll", this.handleScroll);
      // window.removeEventListener("resize", this.handleResize);
    },
    methods: {
      initSeach(){
      this.currentPage =1;
      this.init();
    },
    init(){
      console.log(90);
      let data = {
        op: "app_search",
        page: this.currentPage,
        limit: this.limit,
        title: this.seach,
        type:this.type
       
      };
//model_search  app_search  key_search
      let _this = this;
      this.$axios
        .post("/index.do", _this.Qs.stringify(data), {
          headers: {
            Authorization:
              window.localStorage.getItem("anjing_name_token") || "",
          },
        })
        .then(function (response) {
          console.log(response);
          if (response.data.value == "ok") {
            _this.cardAry = response.data.data;
            _this.total = response.data.count;
            _this.all = response.data.all;
          } else {
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleResize() {
      this.screenWidth = window.innerWidth;
      if (this.screenWidth < 1625) {
        this.limit = 10;
      } else if (this.screenWidth > 1625 && this.screenWidth < 1800) {
        this.limit = 15;
      } else if (this.screenWidth > 1800) {
        this.limit = 25;
      }
      console.log("this.limit", this.limit);
      this.init("this.limit", this.limit);
    },
        handleScroll(e) {
      // 滚动到底部判断（距离底部50px时触发）
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      this.isFixed = scrollTop >= this.tabTop;
      // if (scrollHeight - scrollTop - clientHeight < 50) {
      //   this.loadMoreCourses()
      // }
      if (scrollTop > 38) {
        this.opacity = true;
      } else {
        this.opacity = false;
      }
    },

      clickList(index,name){
        this.indexCur = index;
        this.type=name;
        this.init()
      },
      handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.init()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.init()
    },
     // 时间格式转换方法
     formatDateTime(isoString) {
      const date = new Date(isoString);

      // 处理时区偏移（转换为本地时间）
      const localDate = new Date(
        date.getTime() + date.getTimezoneOffset() * 60000
      );
      /***
   *    ${localDate.getHours().toString().padStart(2, '0')}:
          ${localDate.getMinutes().toString().padStart(2, '0')};
}
   */
      return `${localDate.getFullYear()}年
          ${(localDate.getMonth() + 1).toString().padStart(2, "0")}月
          ${localDate.getDate().toString().padStart(2, "0")}日 `;
    },
    tyurl(index,url){
      window.open(url)
    }
    },
  };
  </script>
  <style scoped>
  .home{
    height: 100vh;
      background: #f5f5f5;
      overflow: auto;
  }
  .home-header {
    background: url("../image/banner.png");
    width: 100vw;
    height: 35vh;
    background-size: cover;
  
  }
  .home-box {
    /* padding-top: 8vh; */
  }
  .home-box-content {
    /* height: 90px; */
    background: #fff;
    width: 100%;
    padding: 24px 0;
    box-sizing: border-box;
  }
  .box-list {
    width: 1200px;
    min-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }
  .list-box {
    display: flex;
  }
  .list-box-content {
    display: flex;
    flex-direction: column;
    text-align: left;
    margin-left: 20px;
    color: #666;
    /* border-right:1px solid #E0E0E0 ; */
  }
  .list-box svg {
    margin-top: 6px;
  }
  .header-font{
    width:1200px;
    min-width:1200px;
    margin:0 auto;
    text-align: left;
    padding-top:11vh;
    height: 24vh;
   
    color:#333;
  }
  .box-content-tab{
    display: flex;
    margin:0 auto;
    margin-top:15px;
    min-width: 1200px;
    width:90%
  }
  .content-tab-left{
    width: 250px;
  
    background: #fff;
  }
  .box-list-left{
    padding:12px;
  }
  .box-list-left li{
    text-align: left;
    padding:12px;
    cursor: pointer;
  }
  .content-tab-left .box-list-left li.active{
    background:#4384F4;
    border-radius: 4px;
    color: #fff;
  }
  .box-list-left li:hover{
    background: #f5f5f5;
  
  }

/* 右侧内容适配 */
.content-tab-right {
  margin-left: 10px; /* 250px侧边栏宽度 + 20px间隙 */
  flex: 1;
  margin-right: 10px;
}
.card-box {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  align-items: stretch;
  margin-top: 10px;
}
.home_i p {
  text-align: left;
}
.box-card {
  background: #fff;
  padding: 10px;
  border-radius: 6px;
  border:1px solid #fff
}
.box-card:hover{
  border:1px solid #4384f4
}
.card-item {
  display: flex;
  margin-bottom: 10px;
}
.item-title {
  color: #333333;
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 3px;
}
.item-detail {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  color: #666666;
  font-size: 0.85rem;
  height: 40px;
}
.item-dis {
  margin: 15px 0;
  color: #999;
  font-size: 0.7rem;
}
.item-btn {
  display: flex;
  justify-content: space-around;
}
.item-btn div {
  font-size: 0.85rem;
  color: 333;
  cursor: pointer;
}
.item-btn div.btn-color {
  color:#2c3e50;
}
/***#4384f4; */
.home_i img {
  vertical-align: sub;
}
@media (max-width: 1625px) {
  .card-box {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 1800px) {
  .card-box {
    grid-template-columns: repeat(4, 1fr);
  }
}
/deep/.el-divider--horizontal {
  margin: 0;
}
</style>
<style >
.home-box-content .el-divider--vertical {
  height: 3rem;
  position: static;
}

.home_i .el-input__inner {
  border-radius: 30px;
}
.home_i .el-tag--mini {
  margin-right: 5px;
  color: #4384f4;
  background: #e6f0ff;
  border-color: #e6f0ff;
}
.home_i .el-tag.el-tag--info {

  border-color: #f4f4f4;
    background-color: #f4f4f5;
    color: #909399;
}
.box-card .el-divider--horizontal {
  margin-bottom: 10px;
  margin-top: 15px;
}
.box-card .el-divider--vertical {
  height: 1.5em;
}
.content-tab-left .el-divider--horizontal {
  margin: 0;
}
</style>

  
  